module.exports = __webpack_public_path__ + "static/media/04.8860503e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/04.png
// module id = 175
// module chunks = 0